class SiteLookupService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
        this.siteList = [];
    }

    /**
     * fetchSites
     *  Initial fetch call to retrieve the facility data.  Called from the resolve for the main Site Lookup route
     *
     *  @returns {Promise}
     */
    fetchSites() {
        return this.$http.get(`${this.appConfig.apiUrl}/campuses/all/`).then((res) => this.siteList = res.data);
    }

    /**
     * getSites
     *  Returns an array containing all of the sites
     *
     * @returns {Array}
     */
    getSites() {
        return this.siteList;
    }

}

export default SiteLookupService;



// WEBPACK FOOTER //
// ./app/components/site-lookup/site-lookup.service.js